/* FB04 — Team selections: horizontal scroll arrows + auto-scroll active card into view. */
(function() {
  if (window.__fb4SelectionsInit) return;
  window.__fb4SelectionsInit = true;

  function bindArrows(root) {
    var track = root.querySelector('[data-fb4-selections-track]');
    var prev = root.querySelector('[data-fb4-sel-prev]');
    var next = root.querySelector('[data-fb4-sel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.fb4-team-card');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '16');
      return card.getBoundingClientRect().width + gap;
    }
    function refresh() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function() { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function() { track.scrollBy({ left:  step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', function() { requestAnimationFrame(refresh); }, { passive: true });
    window.addEventListener('resize', refresh);
    setTimeout(refresh, 50);
  }

  // Scroll the active team card into view (centered horizontally within the track).
  function scrollActiveIntoView(root) {
    var track = root.querySelector('[data-fb4-selections-track]');
    if (!track) return;
    // Find the FIRST visible active card (respecting current data-active-type filter).
    var activeCards = track.querySelectorAll('.fb4-team-card.is-active');
    if (!activeCards.length) return;
    var activeType = root.getAttribute('data-active-type') || 'c';
    var target = null;
    for (var i = 0; i < activeCards.length; i++) {
      var t = activeCards[i].getAttribute('data-team-type') || 'c';
      if (t === activeType) { target = activeCards[i]; break; }
    }
    if (!target) target = activeCards[0];

    // If active card's type doesn't match current tab, switch the tab to match.
    var cardType = target.getAttribute('data-team-type') || 'c';
    if (cardType !== activeType) {
      root.setAttribute('data-active-type', cardType);
      root.querySelectorAll('[data-fb4-type-tab]').forEach(function(b){
        var act = b.getAttribute('data-fb4-type-tab') === cardType;
        b.classList.toggle('is-active', act);
        b.setAttribute('aria-selected', act ? 'true' : 'false');
      });
    }

    // Wait a beat for layout to settle, then center the target card.
    requestAnimationFrame(function(){
      var trackWidth = track.clientWidth;
      var cardLeft = target.offsetLeft;
      var cardWidth = target.offsetWidth;
      var offset = cardLeft - (trackWidth - cardWidth) / 2;
      var maxScroll = track.scrollWidth - track.clientWidth;
      offset = Math.max(0, Math.min(offset, maxScroll));
      // Smooth scroll if supported.
      try {
        track.scrollTo({ left: offset, behavior: 'smooth' });
      } catch (e) {
        track.scrollLeft = offset;
      }
    });
  }

  function init() {
    var root = document.querySelector('[data-fb4-selections-root]');
    if (!root) return;
    bindArrows(root);
    scrollActiveIntoView(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
